/**
 * Bill Validation — the retailer list behind the parse dropdown.
 *
 * Hits the bill validation router, not the tender `/api/scopingai/retailers`
 * one, so BV does not depend on a tender endpoint and can never receive the
 * tender prompt columns.
 */

import { supabase } from '../../../foundation/altzero_base/base/utils/supabaseClient';
import type { ApiResponse } from '../types/billValidationTypes';

const API_BASE = (import.meta.env.VITE_API_URL ?? 'http://localhost:3001') + '/api/bill-validation/email';

export type BvParseRetailer = {
  id: string;
  name: string;
  /** True only when the flag is on AND a prompt is actually saved. */
  has_bill_prompt: boolean;
};

async function authHeaders(): Promise<Record<string, string>> {
  const { data: { session } } = await supabase.auth.getSession();
  return {
    'Content-Type': 'application/json',
    'x-api-key': 'scopingai',
    ...(session?.user?.id ? { 'x-user-id': session.user.id } : {}),
    ...(session?.access_token ? { Authorization: `Bearer ${session.access_token}` } : {}),
  };
}

export const billRetailerService = {
  list: async (): Promise<ApiResponse<BvParseRetailer[]>> => {
    try {
      const res = await fetch(`${API_BASE}/retailers`, { headers: await authHeaders() });
      const json = await res.json() as { success: boolean; data?: BvParseRetailer[]; error?: string };
      if (!res.ok || !json.success) return { success: false, error: json.error ?? `Request failed (${res.status})` };
      return { success: true, data: json.data ?? [] };
    } catch (error: unknown) {
      return { success: false, error: (error as Error).message };
    }
  },
};
